<div class="layout-row align-center bgr bgr-electric-purple trial-us">
  <div class="flex row-desktop">
    <div class="img-holder section-img rounded">
      <img [src]="cdnPath + '/develop/join-today.jpg?v=1'" alt="" />
    </div>
    <div class="layout-column align-center copy-wrapper half-section">
      <h2 class="txt-white">Join today & start learning instantly</h2>
      <p class="txt-white">Debit card + app + Money Missions</p>
      <h3 class="txt-white">30 days free, then plans from $5/month</h3>
      <a id="" class="btn btn-primary" href="//signup.gohenry.com/us/parent-details/" rel="noopener">Get started today</a>
      <p class="small disclaimer txt-white">Order your card in minutes. Cancel anytime.</p>
    </div>
  </div>
</div>
